export enum UF {
    AC = "Acre",
    AL = "Alagoas",
    AM = "Amazonas",
    AP = "Amapá",
    BA = "Bahia",
    CE = "Ceará",
    DF = "Distrito Federal",
    ES = "Espírito Santo",
    GO = "Goiás",
    MA = "Maranhão",
    MG = "Minas Gerais",
    MS = "Mato Grosso do Sul",
    MT = "Mato Grosso",
    PA = "Pará",
    PB = "Paraíba",
    PE = "Pernambuco",
    PI = "Piauí",
    PR = "Paraná",
    RJ = "Rio de Janeiro",
    RN = "Rio Grande do Norte",
    RO = "Rondônia",
    RR = "Roraima",
    RS = "Rio Grande do Sul",
    SC = "Santa Catarina",
    SE = "Sergipe",
    SP = "São Paulo",
    TO = "Tocantins",
};

export interface UfOption { key: string; label: string; }

export const UF_OPTIONS: UfOption[] =
  Object.entries(UF)
    .map(([key, label]) => ({ key, label }))
    .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));